import React, { useEffect } from 'react';
import FlatButton from 'material-ui/FlatButton';
import InviteLeadForm from './application_creator/InviteLeadForm';
import { AccentColor } from 'helpers/AccentColorHelper';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { toFriendlyDateString } from 'helpers/Formatter';
import { colors } from 'helpers/ColorHelper';

const InviteLead = props => {
  const {
    handleSubmit,
    handleClose,
    properties,
    trafficSources,
    showInviteLeadDialog,
    units,
    getUnits,
    clearUnits,
    unitMarketRent,
    unitAbsoluteRent,
    unitMarketRentSixMonths,
    unitDepositAmount,
    currentLeasesOfUnit,
    getCurrentLeasesOfUnit,
    clearCurrentLeasesOfUnit,
    getUnitDetails,
    submit,
    transferApplication,
    leaseDetails,
    landlordLeads,
    disableLeaseWizardSelections,
    onlyYardiBasedProperties,
    submitting,
  } = props;

  useEffect(
    () => {
      if (!showInviteLeadDialog) {
        clearCurrentLeasesOfUnit();
        clearUnits();
      }
    },
    [showInviteLeadDialog, clearCurrentLeasesOfUnit, clearUnits]
  );

  const dialogTitle = transferApplication ? 'Transfer Application' : 'Invite Lead to Apply';
  const dialogInfo = transferApplication
    ? `Transfer this application to another unit by reselecting the details below. Note: The current move in date is set for ${toFriendlyDateString(
        leaseDetails.early_move_in_date
      )} with a move out date of ${toFriendlyDateString(leaseDetails.lease_end_date)}`
    : 'Invite a lead to apply to rent using our online application form. Select a property and add their email address to send them a link to the application form. Applicants without email addresses can manually be added in after inviting them to apply.';

  return (
    <Dialog
      disableBackdropClick
      fullScreen={props.fullScreen}
      open={showInviteLeadDialog}
      onClose={handleClose}
      aria-labelledby="invite-lead-to-apply"
      classes={{
        paper: 'form-dialog',
      }}
    >
      <DialogTitle id="add-new-amenity">
        <h3 style={{ textAlign: 'center', margin: 0 }}>{dialogTitle}</h3>
      </DialogTitle>
      <DialogContent>
        <div className="row" style={{ padding: '0 15px' }}>
          <p>{dialogInfo}</p>
        </div>
        <InviteLeadForm
          onSubmit={handleSubmit}
          properties={properties}
          trafficSources={trafficSources}
          getUnits={getUnits}
          getCurrentLeasesOfUnit={getCurrentLeasesOfUnit}
          clearCurrentLeasesOfUnit={clearCurrentLeasesOfUnit}
          currentLeasesOfUnit={currentLeasesOfUnit}
          units={units}
          unitAbsoluteRent={unitAbsoluteRent}
          unitMarketRent={unitMarketRent}
          unitMarketRentSixMonths={unitMarketRentSixMonths}
          unitDepositAmount={unitDepositAmount}
          getUnitDetails={getUnitDetails}
          transferApplication={transferApplication}
          landlordLeads={landlordLeads}
          disableLeaseWizardSelections={disableLeaseWizardSelections}
          onlyYardiBasedProperties={onlyYardiBasedProperties}
        />
      </DialogContent>
      <DialogActions style={{ display: 'block' }}>
        <FlatButton onClick={handleClose} id="close-button" style={{ color: AccentColor() }}>
          CANCEL
        </FlatButton>
        <FlatButton
          variant="raised"
          disabled={submitting}
          onClick={() => submit('add_lead_form')}
          id="submit-button"
          style={{
            color: 'white',
            backgroundColor: submitting ? colors.LIGHT_GRAY : AccentColor(),
          }}
        >
          SEND
        </FlatButton>
      </DialogActions>
    </Dialog>
  );
};

export default withMobileDialog()(InviteLead);
